export const I18nPrefix = 'strava.subscriptions.checkout';

export default { I18nPrefix };
